module.exports = __webpack_public_path__ + "static/media/IMG-3.780a6af3.jpg";